import { redirect, type LoaderFunctionArgs } from 'react-router';
import { loadOnboarding, onboardingComplete } from '../lib/onboarding/store';
import { currentSession, identityOf } from '../lib/supabase';
import type { RootLoaderData } from '../lib/types';
import { welcomeSeen } from '../lib/welcome';

/**
 * The welcome is where induction ends, once. After that the address leads to
 * the studio — except with `?replay`, which exists so the page can be looked at
 * again without clearing storage.
 */
export async function welcomeLoader({ request }: LoaderFunctionArgs): Promise<RootLoaderData | Response> {
  const session = await currentSession();
  if (!session) return redirect('/signed-out');

  const profile = await loadOnboarding(session);
  if (!onboardingComplete(profile)) return redirect('/onboarding');

  const replay = new URL(request.url).searchParams.has('replay');
  if (!replay && welcomeSeen(session.user.id)) return redirect('/');

  return { identity: identityOf(session), profile };
}
